// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"8ab99f21","193":"4d10f405","344":"be5920af","453":"9d2ab285","492":"a19dfbb4","587":"3264b2dc","640":"e42b9a4e","695":"26a31ea6","727":"6bce983f","821":"678dfbc2","842":"af527797","938":"b384654d"}[chunkId] + ".chunk.js";
};